import axios from 'axios';
import { createAsyncThunk, createSlice, current } from '@reduxjs/toolkit';

import {
  showSnackbar,
} from '../snackbar/snackbarSlice'
import socket from '../../app/socket'

const bc_token = localStorage.getItem('bc_token')
const token = (bc_token === 'null' || bc_token === undefined)
  ? null
  : bc_token

//console.log('found token in localStorage', token)

const initialState = {
  user: null,
  token,
  login: {
    loading: false,
    error: null,
    success: false,
  },
  register: {
    loading: false,
    error: null,
    success: false,
  },
  request_verify: {
    loading: false,
    error: null,
    success: false,
  },
  verify: {
    loading: false,
    error: null,
    success: false,
  },
  forgot_password: {
    loading: false,
    error: null,
    success: false,
  },
  password_reset: {
    loading: false,
    error: null,
    success: false,
  },
  me: {
    loading: false,
    error: null,
    success: false,
  },
  feedback: {
    loading: false,
    error: null,
    success: false,
  }
};

export const getMe = createAsyncThunk(
  'auth/getMe',
  async({token}, {rejectWithValue, dispatch}) => {
    console.log('[auth/getMe] token=', token)
    try {
      const { data } = await axios.get(
        process.env.REACT_APP_API_BASE_URL + '/api/me',
        {
          'headers': {
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        })
      //console.log('[getMe] data=', data)
      return data
    } catch (error) {
      if (error.response && error.response.data.error) {
        dispatch(showSnackbar({
          message: error.response.data.error,
          severity: 'error'
        }))
        return rejectWithValue(error.response.data.error)
      } else {
        dispatch(showSnackbar({
          message: error.message,
          severity: 'error'
        }))
        return rejectWithValue(error.message)
      }
    }
  }
);

export const doVerify = createAsyncThunk(
  'auth/verify',
  async({verification_token, verification_code}, {rejectWithValue, dispatch}) => {
    try {
      //console.log('[doVerify]', verification_code);
      await axios.post(
        process.env.REACT_APP_API_BASE_URL + '/api/verify',
        { verification_code },
        {
          'headers': {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${verification_token}`
          }
        })
      dispatch(showSnackbar({
        message: 'Your account is verified',
        severity: 'success'
      }))
    } catch (error) {
      if (error.response && error.response.data.error) {
        dispatch(showSnackbar({
          message: error.response.data.error,
          severity: 'error'
        }))
        return rejectWithValue(error.response.data.error)
      } else {
        dispatch(showSnackbar({
          message: error.message,
          severity: 'error'
        }))
        return rejectWithValue(error.message)
      }
    }
  }
);

export const doLogin = createAsyncThunk(
  'auth/login',
  async ({email, password}, {rejectWithValue, dispatch}) => {
    try {
      //console.log('[doLogin]', email, password);
      const { data } = await axios.post(
        process.env.REACT_APP_API_BASE_URL + '/api/login',
        { email, password },
        {
          'headers': {
            'Content-Type': 'application/json'
          }
        })
      //console.log('[doLogin]', data);
      localStorage.setItem('bc_token', data.access_token)
      // Identify with Heap
      if (window.heap && data.user) {
        window.heap.identify(data.user.id);
        window.heap.addUserProperties({
          name: data.user.name,
          email: data.user.email,
          verified: data.user.verified,
          native_lang_id: data.user.native_lang_id,
          default_lang_id: data.user.default_lang_id,
        });
      }
      return data;
    } catch (error) {
      if (error.response && error.response.data.error) {
        dispatch(showSnackbar({
          message: error.response.data.error,
          severity: 'error'
        }))
        return rejectWithValue(error.response.data.error)
      } else {
        dispatch(showSnackbar({
          message: error.message,
          severity: 'error'
        }))
        return rejectWithValue(error.message)
      }
    }
  }
);

export const doForgotPassword = createAsyncThunk(
  'auth/forgotPassword',
  async ({email}, {rejectWithValue, dispatch}) => {
    try {
      //console.log('[doForgotPassword]', email)
      const { data } = await axios.post(
        process.env.REACT_APP_API_BASE_URL + '/api/forgot-password',
        { email },
        {
          'headers': {
            'Content-Type': 'application/json',
          }
        })
    } catch (error) {
      if (error.response && error.response.data.error) {
        dispatch(showSnackbar({
          message: error.response.data.error,
          severity: 'error'
        }))
        return rejectWithValue(error.response.data.error)
      } else {
        dispatch(showSnackbar({
          message: error.message,
          severity: 'error'
        }))
        return rejectWithValue(error.message)
      }
    }
  }
);

export const doPasswordReset = createAsyncThunk(
  'auth/passwordReset',
  async ({password_reset_token, new_password}, {rejectWithValue, dispatch}) => {
    try {
      //console.log('[doPasswordReset]', password_reset_token, new_password)
      const { data } = await axios.post(
        process.env.REACT_APP_API_BASE_URL + '/api/reset-password',
        { new_password },
        {
          'headers': {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${password_reset_token}`
          }
        })
      dispatch(showSnackbar({
        message: 'Your new password is set',
        severity: 'success'
      }))
    } catch (error) {
      if (error.response && error.response.data.error) {
        dispatch(showSnackbar({
          message: error.response.data.error,
          severity: 'error'
        }))
        return rejectWithValue(error.response.data.error)
      } else {
        dispatch(showSnackbar({
          message: error.message,
          severity: 'error'
        }))
        return rejectWithValue(error.message)
      }
    }
  }
);

export const doRequestVerification = createAsyncThunk(
  'auth/requestVerification',
  async ({ email }, {rejectWithValue, dispatch}) => {
    try {
      const { data } = await axios.post(
        process.env.REACT_APP_API_BASE_URL + '/api/request-verification',
        {
          email,
        },
        {
          'headers': {
            'Content-Type': 'application/json'
          }
        })
      dispatch(showSnackbar({
        message: 'Verification email sent',
        severity: 'success'
      }))
      return data;
    } catch (error) {
      if (error.response && error.response.data.error) {
        dispatch(showSnackbar({
          message: error.response.data.error,
          severity: 'error'
        }))
        return rejectWithValue(error.response.data.error)
      } else {
        dispatch(showSnackbar({
          message: error.message,
          severity: 'error'
        }))
        return rejectWithValue(error.message)
      }
    }
  }
);

export const doRegister = createAsyncThunk(
  'auth/register',
  async ({name, email, password, native_lang_id, default_lang_id}, {rejectWithValue, dispatch}) => {
    try {
      //console.log('[doRegister]', name, email, password, native_lang_id, default_lang_id);
      const { data } = await axios.post(
        process.env.REACT_APP_API_BASE_URL + '/api/register',
        {
          name,
          email,
          password,
          native_lang_id,
          default_lang_id
        },
        {
          'headers': {
            'Content-Type': 'application/json'
          }
        })
      //console.log('[doRegister]', data);
      dispatch(showSnackbar({
        message: 'Registered! Verify before logging in',
        severity: 'success'
      }))
      return data;
    } catch (error) {
      if (error.response && error.response.data.error) {
        dispatch(showSnackbar({
          message: error.response.data.error,
          severity: 'error'
        }))
        return rejectWithValue(error.response.data.error)
      } else {
        dispatch(showSnackbar({
          message: error.message,
          severity: 'error'
        }))
        return rejectWithValue(error.message)
      }
    }
  }
);

export const updateUser = createAsyncThunk(
  'auth/updateUser',
  async ({name, email, native_lang_id, default_lang_id, email_notifications}, {rejectWithValue, dispatch, getState}) => {
    try {
      //console.log('[updateUser]', name, email, native_lang_id, default_lang_id);
      const token = localStorage.getItem('bc_token')
      const { data } = await axios.patch(
        process.env.REACT_APP_API_BASE_URL + '/api/me',
        {
          name,
          native_lang_id,
          default_lang_id,
          email_notifications,
        },
        {
          'headers': {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        })
      //console.log('[doUpdateUser]', data);
      dispatch(showSnackbar({
        message: 'Your profile has been updated',
        severity: 'success'
      }))
      return {name, native_lang_id, default_lang_id, email_notifications}
    } catch (error) {
      if (error.response && error.response.data.error) {
        dispatch(showSnackbar({
          message: error.response.data.error,
          severity: 'error'
        }))
        return rejectWithValue(error.response.data.error)
      } else {
        dispatch(showSnackbar({
          message: error.message,
          severity: 'error'
        }))
        return rejectWithValue(error.message)
      }
    }
  }
);

export const postFeedback = createAsyncThunk(
  'auth/postFeedback',
  async ({ text }, {rejectWithValue, dispatch, getState}) => {
    try {
      //console.log('[updateUser]', name, email, native_lang_id, default_lang_id);
      const token = localStorage.getItem('bc_token')
      const { data } = await axios.post(
        process.env.REACT_APP_API_BASE_URL + '/api/feedbacks',
        {
          text
        },
        {
          'headers': {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        })
      //console.log('[doUpdateUser]', data);
      dispatch(showSnackbar({
        message: 'Thanks for your feedback!',
        severity: 'success'
      }))
      return { text }
    } catch (error) {
      if (error.response && error.response.data.error) {
        dispatch(showSnackbar({
          message: error.response.data.error,
          severity: 'error'
        }))
        return rejectWithValue(error.response.data.error)
      } else {
        dispatch(showSnackbar({
          message: error.message,
          severity: 'error'
        }))
        return rejectWithValue(error.message)
      }
    }
  }
);

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      //console.log('[authSlice.logout]')
      localStorage.removeItem('bc_token') // deletes token from storage
      state.login.loading = false
      state.login.success = false
      state.login.error = null
      state.user = null
      state.token = null
      // DISCONNECT FROM WEBSOCKET
      socket.disconnect()
    },
    setCredentials: (state, action) => {
      state.user = action.payload.user
    },
    setUser: (state, action) => {
      //console.log('[setUser]', action)
      state.user = {...state.user, ...action.payload}
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(doLogin.pending, (state) => {
        //console.log('[doLogin.pending]', current(state));
        state.login.loading = true;
        state.login.error = null;
      })
      .addCase(doLogin.fulfilled, (state, action) => {
        //console.log('[doLogin.fulfilled]', action);
        localStorage.setItem('bc_token', action.payload.access_token)
        state.user = action.payload.user;
        state.token = action.payload.access_token;
        state.login.loading = false;
        state.login.success = true;
      })
      .addCase(doLogin.rejected, (state, action) => {
        //console.log('[doLogin.rejected]', action)
        state.login.loading = false
        state.login.success = false
        state.login.error = action.payload
      })
      .addCase(doRegister.pending, (state) => {
        //console.log('[doRegister.pending]', current(state));
        state.register.loading = true
        state.register.error = null
      })
      .addCase(doRegister.fulfilled, (state, action) => {
        //console.log('[doRegister.fulfilled]', action);
        localStorage.setItem('verification_token', action.payload.verification_token)
        state.register.loading = false
        state.register.success = true
        //console.log('[doRegister.fulfilled].after', current(state));
      })
      .addCase(doRegister.rejected, (state, action) => {
        //console.log('[doRegister.rejected]', action)
        state.register.loading = false
        state.register.success = false
        state.register.error = action.payload
      })
      .addCase(doRequestVerification.pending, (state) => {
        //console.log('[doRequestVerification.pending]', current(state));
        state.request_verify.loading = true
        state.request_verify.error = null
      })
      .addCase(doRequestVerification.fulfilled, (state, action) => {
        //console.log('[doRequestVerification.fulfilled]', action);
        localStorage.setItem('verification_token', action.payload.verification_token)
        state.request_verify.loading = false
        state.request_verify.success = true
        //console.log('[doRequestVerification.fulfilled].after', current(state));
      })
      .addCase(doRequestVerification.rejected, (state, action) => {
        //console.log('[doRequestVerification.rejected]', action)
        state.request_verify.loading = false
        state.request_verify.success = false
        state.request_verify.error = action.payload
      })
      .addCase(doVerify.pending, (state) => {
        //console.log('[doVerify.pending]', current(state));
        state.verify.loading = true
        state.verify.error = null
      })
      .addCase(doVerify.fulfilled, (state, action) => {
        //console.log('[doVerify.fulfilled]', action);
        state.verify.loading = false
        state.verify.success = true
        //console.log('[doVerify.fulfilled].after', current(state));
      })
      .addCase(doVerify.rejected, (state, action) => {
        //console.log('[doVerify.rejected]', action)
        state.verify.loading = false
        state.verify.success = false
        state.verify.error = action.payload
      })
      .addCase(doForgotPassword.pending, (state) => {
        //console.log('[doForgotPassword.pending]', current(state));
        state.forgot_password.loading = true
        state.forgot_password.error = null
      })
      .addCase(doForgotPassword.fulfilled, (state, action) => {
        //console.log('[doForgotPassword.fulfilled]', action);
        state.forgot_password.loading = false
        state.forgot_password.success = true
        //console.log('[doForgotPassword.fulfilled].after', current(state));
      })
      .addCase(doForgotPassword.rejected, (state, action) => {
        //console.log('[doForgotPassword.rejected]', action)
        state.forgot_password.loading = false
        state.forgot_password.success = false
        state.forgot_password.error = action.payload
      })
      .addCase(doPasswordReset.pending, (state) => {
        //console.log('[doPasswordReset.pending]', current(state));
        state.password_reset.loading = true
        state.password_reset.error = null
      })
      .addCase(doPasswordReset.fulfilled, (state, action) => {
        //console.log('[doPasswordReset.fulfilled]', action);
        state.password_reset.loading = false
        state.password_reset.success = true
        //console.log('[doPasswordReset.fulfilled].after', current(state));
      })
      .addCase(doPasswordReset.rejected, (state, action) => {
        //console.log('[doPasswordReset.rejected]', action)
        state.password_reset.loading = false
        state.password_reset.success = false
        state.password_reset.error = action.payload
      })
      .addCase(getMe.pending, (state) => {
        //console.log('[getMe.pending]', current(state));
        state.me.loading = true
        state.me.error = null
      })
      .addCase(getMe.fulfilled, (state, action) => {
        //console.log('[getMe.fulfilled]', action);
        state.me.loading = false
        state.me.success = true
        state.user = action.payload.user
        //console.log('[getMe.fulfilled].after', current(state));
      })
      .addCase(getMe.rejected, (state, action) => {
        //console.log('[getMe.rejected]', action)
        state.me.loading = false
        state.me.success = false
        state.me.error = action.payload
      })
      .addCase(updateUser.pending, (state, action) => {
        //console.log('[updateUser.pending]', action, current(state));
        state.me.loading = true
        state.me.error = null
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        //console.log('[updateUser.fulfilled]', action);
        state.me.loading = false
        state.me.success = true
        state.user = {...state.user, ...action.payload}
        //console.log('[updateUser.fulfilled].after', current(state));
      })
      .addCase(updateUser.rejected, (state, action) => {
        //console.log('[updateUser.rejected]', action)
        state.me.loading = false
        state.me.success = false
        state.me.error = action.payload
      })
      .addCase(postFeedback.pending, (state, action) => {
        //console.log('[postFeedback.pending]', action, current(state));
        state.feedback.loading = true
        state.feedback.error = null
      })
      .addCase(postFeedback.fulfilled, (state, action) => {
        //console.log('[postFeedback.fulfilled]', action);
        state.feedback.loading = false
        state.feedback.success = true
        //console.log('[postFeedback.fulfilled].after', current(state));
      })
      .addCase(postFeedback.rejected, (state, action) => {
        //console.log('[postFeedback.rejected]', action)
        state.feedback.loading = false
        state.feedback.success = false
        state.feedback.error = action.payload
      })
  },
});

export const selectUser = (state) => state.auth.user;

export const { logout, setCredentials, setUser } = authSlice.actions

export default authSlice.reducer
